import React from "react";
import styled from "styled-components";
import Logo from "./images/saiyan-logo.png";

import sunbreak2017 from "./images/team-pictures/sunbreak-2017.png";
import phillipines2017 from "./images/team-pictures/phillipines-2017.jpg";

import gnarly2018 from "./images/team-pictures/gnarly-2018.jpg";
import sunbreak2018 from "./images/team-pictures/sunbreak-2018.png";
import mexico2018 from "./images/team-pictures/mexico-2018.png";

import jamboree2019 from "./images/team-pictures/jamboree-2019.png";
import sunbreak2019 from "./images/team-pictures/sunbreak-2019.png";
import hanford2019 from "./images/team-pictures/hanford-2019.png";

import practice2020 from "./images/team-pictures/virtual-practice.png";
import gnarly2022 from "./images/team-pictures/gnarly-gnines-2022.jpg";
import sunbreak2022 from "./images/team-pictures/sunbreak-2022.png";
import leiout2023 from "./images/team-pictures/lei-out-2023.png";

function App2() {
  const Container = styled.div`
    font-family: "Avenir", sans-serif;
    letter-spacing: 1px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    max-width: 900px;
    margin: 0 auto;
    text-align: center;
  `;
  const PageTitle = styled.h1`
    font-family: "Grobold", serif;
    font-size: 64px;
  `;
  const Tournament = styled.img`
    width: 100vw;
    max-width: 1100px;
    object-fit: contain;
  `;

  const ImageContainer = styled.div`
    text-align: center;
    margin: 30px 0;
  `;

  const Statistics = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);

    @media (max-width: 900px) {
      grid-template-columns: 1fr;
    }

    margin-top: 40px;
  `;
  const Stat = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `;

  const StyledLogo = styled.img`
    width: 20vw;
    max-width: 200px;
    margin: 10px 0;
  `;

  const StyledDesktopLogo = styled.img`
    width: 20vw;
    max-width: 200px;
    margin: 10px 0;

    @media (max-width: 900px) {
      display: none;
    }
  `;

  const PageHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    @media (max-width: 900px) {
      display: block;
    }
  `;
  const Number = styled.strong`
    font-size: 24px;
  `;
  const TournamentName = styled.strong`
    font-family: "Grobold", serif;
    font-size: 32px;
    margin: 20px;
    display: block;
  `;

  const tournaments = [
    {
      name: "Sunbreak",
      year: "2017",
      location: "Redmond, Washington",
      picture: sunbreak2017,
    },
    {
      name: "Manila Spirits",
      year: "2017",
      location: "Manila, Phillipines",
      picture: phillipines2017,
    },
    {
      name: "Gnarly Gnines",
      year: "2018",
      location: "Bellingham, Washington",
      picture: gnarly2018,
    },
    {
      name: "Sunbreak",
      year: "2018",
      location: "Redmond, Washington",
      picture: sunbreak2018,
    },
    {
      name: "Ulticopa",
      year: "2018",
      location: "Mexico City, Mexico",
      picture: mexico2018,
    },
    {
      name: "Jamboree",
      year: "2019",
      location: "Anchorage, Alaska",
      picture: jamboree2019,
    },
    {
      name: "Sunbreak",
      year: "2019",
      location: "Redmond, Washington",
      picture: sunbreak2019,
    },
    {
      name: "Hanford Howl",
      year: "2019",
      location: "Hanford, Washington",
      picture: hanford2019,
    },
    {
      name: "Virtual Practice",
      year: "2020",
      location: "Our couches",
      picture: practice2020,
    },
    {
      name: "Gnarly Gnines",
      year: "2022",
      location: "Bellingham, Washington",
      picture: gnarly2022,
    },
    {
      name: "Sunbreak",
      year: "2022",
      location: "Redmond, Washington",
      picture: sunbreak2022,
    },
    {
      name: "Lei Out",
      year: "2023",
      location: "Huntington Beach, California",
      picture: leiout2023,
    },
  ];
  return (
    <Container>
      <PageHeader>
        <StyledLogo src={Logo} />
        <PageTitle>Just Saiyan</PageTitle>
        <StyledDesktopLogo src={Logo} />
      </PageHeader>
      <h2>Through the years...</h2>
      <p>
        Hi! We're Just Saiyan. We're an ultimate frisbee team based in Seattle,
        Washington, where we compete in DiscNW's B League. We also love to
        attend tournaments, as you can see in the following photos. Thanks for
        stopping by!
      </p>
      <p>A few quick statistics...</p>
      <Statistics>
        <Stat>
          <Number>8</Number>
          <p>Years Together</p>
        </Stat>
        <Stat>
          <Number>11</Number>
          <p>Tournaments Attended</p>
        </Stat>
        <Stat>
          <Number>3</Number>
          <p>Countries Played In</p>
        </Stat>
        <Stat>
          <Number>∞</Number>
          <p>Just Saiyan Juice Consumed</p>
        </Stat>
      </Statistics>
      {tournaments.reverse().map((t) => (
        <ImageContainer>
          <Tournament src={t.picture} />
          <TournamentName>{t.name}</TournamentName>
          <div>{t.year}</div>
          <div>{t.location}</div>
        </ImageContainer>
      ))}
    </Container>
  );
}

export default App2;
